class SpendingAccountSummary {
  constructor() {
    this.spendingAccountSummary = null;
    this.AccountNumber = [];
    this.Order = [];
    this.AccountType = [];
    this.Year = [];
    this.AnnualContribution = [];
    this.AmountSpent = [];
    this.MemberFlag = false;
  }

  setMemberFlag(memberFlag) {
    this.MemberFlag = memberFlag;
  }

  getMemberFlag() {
    return this.MemberFlag;
  }

  getSpendingAccountSummary() {
    return this.spendingAccountSummary;
  }

  setSpendingAccountSummary(spendingAccountSummary) {
    this.spendingAccountSummary = spendingAccountSummary;
  }

  getAccountNumber(iIndex) {
    return this.AccountNumber[iIndex];
  }

  setAccountNumber(iIndex, accountNumber) {
    this.AccountNumber[iIndex] = accountNumber;
  }

  getOrder(iIndex) {
    return this.Order[iIndex];
  }

  setOrder(iIndex, order) {
    this.Order[iIndex] = order;
  }

  getAccountType(iIndex) {
    return this.AccountType[iIndex];
  }

  setAccountType(iIndex, accountType) {
    this.AccountType[iIndex] = accountType;
  }

  getYear(iIndex) {
    return this.Year[iIndex];
  }

  setYear(iIndex, year) {
    this.Year[iIndex] = year;
  }

  getAnnualContribution(iIndex) {
    return this.AnnualContribution[iIndex];
  }

  setAnnualContribution(iIndex, annualContribution) {
    this.AnnualContribution[iIndex] = annualContribution;
  }

  getAmountSpent(iIndex) {
    return this.AmountSpent[iIndex];
  }

  setAmountSpent(iIndex, amountSpent) {
    this.AmountSpent[iIndex] = amountSpent;
  }

  resetSpendingSummary() {
    this.spendingAccountSummary = null;
    this.AccountNumber = [];
    this.Order = [];
    this.AccountType = [];
    this.Year = [];
    this.AnnualContribution = [];
    this.AmountSpent = [];
  }
}
export default new SpendingAccountSummary();
